import MoreInfoImg from "../../../../../pngs/MoreInfo.png";

const MoreInfo = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center py-[20px] mt-4 lg:mt-6 border-t border-stroke1">
      <h2 className="my-10 text-text3 text-[22px] md:text-[32px]">
        More information about
      </h2>
      <div className="w-[80%] aspect-video max-w-[800px] flex justify-center items-center rounded-xl border border-stroke2">
        <img src={MoreInfoImg} alt="" className="w-[90%] h-[90%]" />
      </div>
    </div>
  );
};

export default MoreInfo;
